
import React, { useEffect, useState } from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { fetch } from '../../utils'; // Assuming fetch is correctly implemented in utils


const SearchComponent = () => {
    const [searchProductList, setSearchProductList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showSearch, setShowSearch] = useState(false);

    // const searchProduct = async () => {
    //     try {
    //         const response = await fetch("/product/all-search", "get", null, null);
    //         setSearchProductList(response.data.data.product_list);
    //     } catch (err) {
    //         setError(err.message); // Set error state if fetching fails
    //     } finally {
    //         setLoading(false); // No matter what, after fetching, loading state should be set to false
    //     }
    // }
    // useEffect(() => {
    //     searchProduct();
    // }, []);

    const handleOnSearch = (string, results) => {
    }
   

    const handleOnSelect = (item) => {
        const selectedProduct = searchProductList.find(product => product.product_name === item.name);
        if (selectedProduct) {
            const { category_slug, sub_category_slug, product_slug } = selectedProduct;
            window.location.href = `/${category_slug}/${sub_category_slug}/${product_slug}`;
        } else {
            const selectedCategory = searchProductList.find(product => product.category_name === item.name);
            if (selectedCategory) {
                window.location.href = `/${selectedCategory.category_slug}`;
            } else {
                const selectedCategory = searchProductList.find(product => product.sub_category_name === item.name);
                if (selectedCategory) {
                    window.location.href = `/${selectedCategory.category_slug}/${selectedCategory.sub_category_slug}`;
                }
            }
        }
    }
    return (
        <>
            <div className='search-box'>
                {showSearch && (
                    <>
                        <ReactSearchAutocomplete
                            items={[
                                ...searchProductList.map(product => ({ name: product.product_name })),

                                ...searchProductList
                                    .map(product => product.category_name)
                                    .filter((category, index, self) => self.indexOf(category) === index)
                                    .map(category => ({ name: category })),

                                ...searchProductList
                                    .map(product => product.sub_category_name)
                                    .filter((subcategory, index, self) => self.indexOf(subcategory) === index)
                                    .map(subcategory => ({ name: subcategory })),

                            ]}
                            onSearch={handleOnSearch}
                            onSelect={handleOnSelect}
                            autoFocus
                        />

                    </>
                )}

            </div>
            <i onClick={() => setShowSearch(!showSearch)} className='fa fa-search'></i>
        </>
    );
}

export default SearchComponent;


